const perspective = {
  name: "perspective",
  path: "/perspective",
  title: "perspective",
  description: "Utilities for controlling the perspective of an element.",
  value: {
    'perspective': {
          'perspective-dramatic': '100px',
          'perspective-near': '300px',
          'perspective-normal': '500px',
          'perspective-midrange': '800px',
          'perspective-distant': '1200px',
          'perspective-none': 'none',
          'perspective-[<value>]':'<value>'
        },
  },
  exampleData: [
    {
      example: {
        code: `<div class="size-20 perspective-dramatic  ...">
  <div class="translate-z-12 rotate-x-0 bg-color-sky-300/75 backface-hidden ...">1</div>
  <div class="-translate-z-12 rotate-y-18 bg-color-sky-300/75 backface-hidden ...">2</div>
  <div class="translate-x-12 rotate-y-90 bg-color-sky-300/75 backface-hidden ...">3</div>
  <div class="-translate-x-12 -rotate-y-90 bg-color-sky-300/75 backface-hidden ...">4</div>
  <div class="-translate-y-12 rotate-x-90 bg-color-sky-300/75 backface-hidden ...">5</div>
  <div class="translate-y-12 -rotate-x-90 bg-color-sky-300/75 backface-hidden ...">6</div>
</div>
<div class="size-20 perspective-[200px] ...">
  <div class="translate-z-12 rotate-x-0 bg-color-sky-300/75 backface-visible ...">1</div>
  <div class="-translate-z-12 rotate-y-18 bg-color-sky-300/75 backface-visible ...">2</div>
  <div class="translate-x-12 rotate-y-90 bg-color-sky-300/75 backface-visible ...">3</div>
  <div class="-translate-x-12 -rotate-y-90 bg-color-sky-300/75 backface-visible ...">4</div>
  <div class="-translate-y-12 rotate-x-90 bg-color-sky-300/75 backface-visible ...">5</div>
  <div class="translate-y-12 -rotate-x-90 bg-color-sky-300/75 backface-visible ...">6</div>
</div>`
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">perspective-dramatic</code> or <code class="text-color-gray-800 dark:text-color-white font-semibold">perspective-[]</code> to control the <code>perspective</code> property.
      </p>
      <div class="flex flex-col justify-around gap-8 text-sm leading-6 font-bold text-color-white sm:flex-row sm:gap-0">
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-10 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">perspective-dramatic</p>
            <div class="size-40 p-10">
                <div class="size-20 perspective-dramatic rotate-[0.75_1_0.75_45deg] transform-style-3d">
                    <div class="absolute inset-0 translate-z-12 rotate-x-0 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900  dark:bg-color-sky-400/85 dark:text-color-white">1</div>
                    <div class="absolute inset-0 -translate-z-12 rotate-y-180 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 opacity-75  dark:bg-color-sky-400/85 dark:text-color-white">2</div>
                    <div class="absolute inset-0 translate-x-12 rotate-y-90 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 opacity-75  dark:bg-color-sky-400/85 dark:text-color-white">3</div>
                    <div class="absolute inset-0 -translate-x-12 -rotate-y-90 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900  dark:bg-color-sky-400/85 dark:text-color-white">4</div>
                    <div class="absolute inset-0 -translate-y-12 rotate-x-90 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 opacity-75  dark:bg-color-sky-400/85 dark:text-color-white">5</div>
                    <div class="absolute inset-0 translate-y-12 -rotate-x-90 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900  dark:bg-color-sky-400/85 dark:text-color-white">6</div>
                </div>
            </div>
        </div>
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">perspective-[200px]</p>
            <div class="size-40 p-10">
                <div class="size-20 perspective-[200px] rotate-[0.75_1_0.75_45deg] transform-style-3d">
                    <div class="absolute inset-0 translate-z-12 rotate-x-0 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 backface-visible dark:bg-color-sky-400/85 dark:text-color-white">1</div>
                    <div class="absolute inset-0 -translate-z-12 rotate-y-180 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 opacity-75 backface-visible dark:bg-color-sky-400/85 dark:text-color-white">2</div>
                    <div class="absolute inset-0 translate-x-12 rotate-y-90 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 opacity-75 backface-visible dark:bg-color-sky-400/85 dark:text-color-white">3</div>
                    <div class="absolute inset-0 -translate-x-12 -rotate-y-90 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 backface-visible dark:bg-color-sky-400/85 dark:text-color-white">4</div>
                    <div class="absolute inset-0 -translate-y-12 rotate-x-90 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 opacity-75 backface-visible dark:bg-color-sky-400/85 dark:text-color-white">5</div>
                    <div class="absolute inset-0 translate-y-12 -rotate-x-90 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 backface-visible dark:bg-color-sky-400/85 dark:text-color-white">6</div>
                </div>
            </div>
        </div>
        </div>
      `
    }
  ]
};

export default perspective;
<div class="sr-only perspective-dramatic perspective-[200px] perspective-near perspective-midrange perspective-distant perspective-none">
   
</div>